<script setup lang="ts">
    import WorksitePhase from '~~/app/auth/models/WorksitePhase';
    import { FormInputProps, FormInputData } from '~~/composables/useFormInput';

    const emit = defineEmits(['selected', 'changed']);

    interface Props extends FormInputProps {
        worksitePhase: WorksitePhase | null;
    }

    const props = defineProps<Props>();
    const inputData: FormInputData = useFormInput(props);
</script>

<template>
    <FormElement :input-data="inputData">
        <SelectTask
            :initial-value="inputData.model"
            :worksite-phase="worksitePhase"
        ></SelectTask>
    </FormElement>
</template>
